import CustomButton from 'components/CustomInput/Button';
import { Checkbox } from '@material-ui/core';
import { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';

const useSearchMember = ({ selectedRows, setSelectedRows, meetingArrangementMemberList, isEditMode, specialList }) => {
    const [isDisabledAll, setIsDisabledAll] = useState(false);

    const checkedAll = () => {
        let newSpecialList = cloneDeep(specialList);
        let newSelectedRows = cloneDeep(selectedRows);
        newSpecialList.forEach((item) => {
            let index = newSelectedRows.findIndex((ele) => ele.specialId === item.specialId);
            if (index >= 0) {
                if (!newSelectedRows[index].list.find((ele) => ele.id === item.panelNameId)) {
                    newSelectedRows[index].list.push(...item.list);
                }
            } else {
                newSelectedRows.push(item);
            }
        });
        setSelectedRows(newSelectedRows);
    };

    const handleCheck = (value, id) => {
        // if (!isEditMode) return;
        let newSelectedRows = [...selectedRows];
        newSelectedRows.forEach((item) => {
            if (id === item.id) {
                item.chairman = value;
            }
        });
        setSelectedRows(newSelectedRows);
    };

    const handleChecked = (row) => {
        let newSelectedRows = cloneDeep(selectedRows);
        let index = selectedRows.findIndex((item) => item.specialId === row.specialId);
        if (index >= 0) {
            newSelectedRows[index].list.push(...row.list);
            newSelectedRows[index].id = row.specialId;
        } else {
            newSelectedRows = [...newSelectedRows, { ...row, id: row.specialId }];
        }
        setSelectedRows(newSelectedRows);
    };

    useEffect(() => {
        let isDisabled = true;
        let newSpecialList = cloneDeep(specialList);
        if (selectedRows.length === 0) {
            setIsDisabledAll(false);
            return;
        }
        newSpecialList.forEach((item) => {
            if (!selectedRows.find((ele) => ele.specialId === item.specialId)) {
                isDisabled = false;
                return;
            } else {
                selectedRows.forEach((el) => {
                    if (
                        el.specialId === item.specialId &&
                        !el.list.find((ele) => ele.id === item.panelNameId) &&
                        el.list.length > 0
                    ) {
                        isDisabled = false;
                        return;
                    }
                });
            }
        });
        setIsDisabledAll(isDisabled);
    }, [selectedRows, specialList]);

    const gender = (type) => {
        let gender = type || '-';
        switch (type) {
            case 'M':
                gender = 'Male';
                break;
            case 'F':
                gender = 'Female';
                break;
            default:
                break;
        }
        return gender;
    };

    // const fetchMember = (key, isDesc) => {
    //     console.log('%c 154532 useSearchMember.js key, isDesc', 'background: green', key, isDesc);

    //     dispatch({
    //         type: GET_MEETING_ARRANGEMENT_MEMBER_LIST,
    //         payload: {
    //             params: {},
    //             callback: () => {
    //                 // setIsMemberLoading(false);
    //                 // setIsSeach(params);
    //             },
    //         },
    //     });
    // };
    const columns = [
        {
            field: 'action',
            headerName: (
                <div>
                    <CustomButton onClick={checkedAll} disabled={isDisabledAll}>
                        {' '}
                        Add All
                    </CustomButton>
                </div>
            ),
            disableItemSort: true,
            valueGetter: (params) => {
                let isExist = true;
                if (params.row.list.length === 0) {
                    if (!isEditMode) {
                        isExist = selectedRows.some((item) => {
                            return item.id === params.row.specialId;
                        });
                    } else {
                        isExist = selectedRows.some((item) => {
                            return item.specialId === params.row.specialId;
                        });
                    }
                } else {
                    if (!isEditMode) {
                        isExist = selectedRows.some((item) => {
                            return (
                                item.id === params.row.specialId &&
                                (item?.reviewPanel?.find((ele) => ele.id === params.row.list[0]?.id) ||
                                    item?.list?.find((ele) => ele.id === params.row.list[0]?.id))
                            );
                        });
                    } else {
                        isExist = selectedRows.some((item) => {
                            return (
                                item.specialId === params.row.specialId &&
                                item?.list?.find((ele) => ele.id === params.row.list[0]?.id)
                            );
                        });
                    }
                }
                return (
                    <CustomButton
                        disabled={isExist}
                        onClick={() => {
                            if (!isExist) {
                                handleChecked(params.row);
                            }
                        }}
                    >
                        Add
                    </CustomButton>
                );
            },
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 200,
            // onSort: (key, isDesc) => {
            //     fetchMember(key, isDesc);
            // },
        },
        {
            field: 'reviewPanel',
            headerName: 'Review Panel ',
            width: 180,
            sortKey: 'reviewPlanName',
            valueGetter: (params) => {
                let reviewPanel = '';
                params?.row?.list?.forEach((element, i) => {
                    return (reviewPanel +=
                        i === params?.row?.list?.length - 1
                            ? element.panelName || '-'
                            : (element.panelName || '-') + '，');
                });
                return <>{reviewPanel || '-'}</>;
            },
        },
        { field: 'title', headerName: 'Title', width: 100 },
        { field: 'surname', headerName: 'Surname', width: 140 },
        {
            field: 'firstName',
            headerName: 'First Name',
            width: 140,
        },
        {
            field: 'gender',
            headerName: 'Gender',
            width: 100,
            valueGetter: (params) => gender(params.value),
        },
        { field: 'institution', headerName: 'Institution', width: 100 },
        { field: 'department', headerName: 'Department', width: 140 },
        { field: 'post', headerName: 'Post', width: 100 },
        { field: 'background', headerName: 'Background', width: 100 },
        {
            field: 'independent',
            headerName: 'Independent',
            width: 100,
            valueGetter: (params) => (params?.row?.independent === '1' ? 'Yes' : 'No'),
        },
    ];

    const addColumns = [
        { field: 'email', headerName: 'Email', width: 200 },
        {
            field: 'reviewPanel',
            headerName: 'Review Panel ',
            width: 180,
            sortKey: 'reviewPlanName',
            valueGetter: (params) => {
                let reviewPanel = '';
                let reviewPanelList = params?.row?.list || [];
                if (!isEditMode && params?.row?.reviewPanel) {
                    reviewPanelList = reviewPanelList.concat(params?.row?.reviewPanel);
                }
                reviewPanelList?.forEach((element, i) => {
                    return (reviewPanel +=
                        i === reviewPanelList?.length - 1
                            ? element?.panelName || '-'
                            : (element?.panelName || '-') + '，');
                });
                return <>{reviewPanel || '-'}</>;
            },
        },
        { field: 'title', headerName: 'Title', width: 100 },
        { field: 'surname', headerName: 'Surname', width: 140 },
        {
            field: 'firstName',
            headerName: 'First Name',
            width: 140,
        },
        { field: 'gender', headerName: 'Gender', width: 100, valueGetter: (params) => gender(params.value) },
        { field: 'institution', headerName: 'Institution', width: 100 },
        { field: 'department', headerName: 'Department', width: 140 },
        { field: 'post', headerName: 'Post', width: 100 },
        { field: 'background', headerName: 'Background', width: 100 },
        {
            field: 'independent',
            headerName: 'Independent',
            width: 100,
            valueGetter: (params) => (params?.row?.independent === '1' ? 'Yes' : 'No'),
        },
    ];

    const currentColumns = [
        {
            field: 'Chairman',
            headerName: 'Chairman',
            width: 140,
            valueGetter: (params) => {
                return (
                    <Checkbox
                        color="primary"
                        checked={params.row.chairman || false}
                        style={{ padding: 0 }}
                        onChange={(e) => handleCheck(e.target.checked, params.row.id)}
                        disabled={params.row.oldData ?? false}
                    />
                );
            },
        },
        { field: 'email', headerName: 'Email', width: 200 },
        {
            field: 'reviewPanel',
            headerName: 'Review Panel ',
            width: 180,
            valueGetter: (params) => {
                let reviewPanel = '';
                let reviewPanelList = params?.row?.list || [];
                if (!isEditMode && params?.row?.reviewPanel) {
                    reviewPanelList = reviewPanelList.concat(params?.row?.reviewPanel);
                }
                reviewPanelList?.forEach((element, i) => {
                    return (reviewPanel +=
                        i === reviewPanelList?.length - 1
                            ? element?.panelName || '-'
                            : (element?.panelName || '-') + '，');
                });
                return <>{reviewPanel || '-'}</>;
            },
        },
        { field: 'title', headerName: 'Title', width: 100 },
        { field: 'surname', headerName: 'Surname', width: 140 },
        {
            field: 'firstName',
            headerName: 'First Name',
            width: 140,
        },

        { field: 'gender', headerName: 'Gender', width: 100, valueGetter: (params) => gender(params.value) },
        { field: 'institution', headerName: 'Institution', width: 100 },
        { field: 'department', headerName: 'Department', width: 140 },
        { field: 'post', headerName: 'Post', width: 100 },
        { field: 'background', headerName: 'Background', width: 100 },
        {
            field: 'independent',
            headerName: 'Independent',
            width: 100,
            valueGetter: (params) => (params?.row?.independent === '1' ? 'Yes' : 'No'),
        },
        // {
        //     field: 'reviewPanel', headerName: 'Review Panel ', width: 180
        // },
    ];
    return { columns, currentColumns, addColumns };
};

export default useSearchMember;
